import { Component, Input, computed, inject, OnInit, WritableSignal, signal } from '@angular/core';
import { ModalContentData } from '../modal-content';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { SignalsStoreService } from '../../signals-store.service';
import { CommonModule } from '@angular/common';
import { LOCALSTORAGE_KEYS } from '../../constants/databases';
import { LocalStorageService } from '../../local-storage.service';
import { Session } from '../../types/session.type';
import { DateTime } from 'luxon';

interface MarketDay {
  name: string;
  icon?: string;
  longName?: string;
}

@Component({
  selector: 'app-how-it-works',
  imports: [CommonModule],
  templateUrl: './how-it-works.component.html',
  styleUrl: './how-it-works.component.scss'
})
export class HowItWorksComponent implements OnInit {

  activeModal = inject(NgbActiveModal);
  router = inject(Router);
  private signalsStoreService = inject(SignalsStoreService);
  private localStorageService = inject(LocalStorageService);
  marketStatus = computed(() => this.signalsStoreService.marketStatus())

  @Input() modalContentData!: ModalContentData;


  marketOpensIcon = '/assets/images/how-it-works/market-opens.svg';
  finalizeYourOrderIcon = '/assets/images/how-it-works/finalize-your-order.svg';
  deliveryDayIcon = '/assets/images/how-it-works/delivery-day.svg';
  // Market hours data matching the image
  marketHours: WritableSignal<MarketDay[]> = signal([
    { name: 'FRI', icon: this.marketOpensIcon, longName: 'friday' },
    { name: 'SAT', icon: '', longName: 'saturday' },
    { name: 'SUN', icon: '', longName: 'sunday' },
    { name: 'MON', icon: '', longName: 'monday' },
    { name: 'TUES', icon: '', longName: 'tuesday' },
    { name: 'WED', icon: '', longName: 'wednesday' },
    { name: 'THURS', icon: '', longName: 'thursday' },
  ]);

  ngOnInit(): void {
    this.setupMarketHours();
  }

  // Get delivery day from modal content data or use a default
  get deliveryDay(): string {
    return this.modalContentData?.howItWorks?.deliveryDay || 'Delivery Day';
  }

  get cutoffDay(): string {
    return this.modalContentData?.howItWorks?.cutoffDay || 'Cut-off Day';
  }

  private setupMarketHours() {
    const session: Session | null = this.localStorageService.get(LOCALSTORAGE_KEYS.SESSION);
    if (!session) return;
    const cutoffDate = session.deliveryInfo?.cutoffDate;
    const deliveryDate = session.deliveryInfo?.deliveryDate;
    if (!cutoffDate || !deliveryDate) return;
    const cutoffDay = DateTime.fromISO(cutoffDate).toFormat('EEEE').toLowerCase();
    const deliveryDay = DateTime.fromISO(deliveryDate).toFormat('EEEE').toLowerCase();
    this.marketHours.update(prev => prev.map(day => ({
      ...day,
      icon: day.longName === cutoffDay ? this.finalizeYourOrderIcon : day.longName === deliveryDay ? this.deliveryDayIcon : day.icon
    })));
  }

  goTo(route?: string) {
    if (route)
      this.router.navigate([`/${route}`]);
    this.activeModal.close();
  }

}
